<div class="d-flex pt-2" appManageValidatorDisplay [control]="formControl">
  <cap-checkbox [formControl]="formControl" [label]="props.label"> </cap-checkbox>

  @if (props?.tooltip) {
    <i
      appHideFromSummaryPdf
      [pTooltip]="props?.tooltip"
      class="fas fa-info-circle"
      tooltipPosition="top"
      tooltipStyleClass="mt-1">
    </i>
  }
</div>

@if (props?.description) {
  <span class="small-description">{{ props?.description }}</span>
}
